import React from 'react';
import SvgIcon from './SvgIcon';

const AlertsCard = props => {
    return (
        <SvgIcon viewBox="0 0 147 127" {...props}>
            <g id="New" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.15">
                <g
                    id="2-Navigation---Critical-Communications"
                    transform="translate(-446.000000, -441.000000)"
                    fill="#3777BC"
                    fillRule="nonzero"
                >
                    <g id="Shape" transform="translate(298.000000, 392.000000)">
                        <path
                            d="M220.961854,143.532527 L223.483876,146.313967 C228.133856,151.382514 234.360099,154.183727 241.019815,154.183727 C247.681173,154.183727 253.905775,151.389105 258.542619,146.325501 L258.542619,146.325501 L261.136887,143.539118 L312.779242,190.558298 C310.119296,192.425224 306.894523,193.532527 303.413606,193.532527 L303.413606,193.532527 L178.626025,193.532527 C175.361845,193.532527 172.340671,192.550455 169.779242,190.896092 L169.779242,190.896092 L220.961854,143.532527 Z M164.859502,81.7514382 L215.902654,138.800902 L164.728957,186.751438 C162.947016,184.099864 161.902654,180.896087 161.902654,177.446885 L161.902654,177.446885 L161.902654,91.2168435 C161.902654,87.694678 163.005761,84.4378357 164.859502,81.7514382 L164.859502,81.7514382 Z M318.541494,82.2851045 C320.038951,84.802845 320.960966,87.7202268 320.960966,90.8773935 L320.960966,90.8773935 L320.956062,177.473013 C320.956062,180.716768 320.001351,183.714079 318.417251,186.285105 L318.417251,186.285105 L266.960966,138.727784 Z M303.127669,74.7312569 C306.687563,74.7312569 309.965029,75.8962949 312.664505,77.8140259 L312.664505,77.8140259 L253.440227,141.223507 C246.655411,148.573719 234.800047,148.555719 228.048072,141.238234 L228.048072,141.238234 L169.664505,77.2576876 C172.186644,75.6803047 175.148843,74.7312569 178.334357,74.7312569 L178.334357,74.7312569 Z"
                            id="alerts"
                            transform="translate(241.431810, 134.131892) rotate(-30.000000) translate(-241.431810, -134.131892) "
                        ></path>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

AlertsCard.displayName = 'AlertsCardIcon';

export default AlertsCard;
